<template>
  <div class="product-count-chart-history-slot">
    <canvas id="chart-history" class="frame"></canvas>
  </div>
</template>

<script>
import layoutMixin from "@/mixins/layoutMixin";
import { BFormInput, BFormGroup, BButton } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Chart from "chart.js/auto";
import axios from "@axios";
import { computed, watch, onBeforeUnmount, nextTick } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";

export default {
  mixins: [layoutMixin],
  components: {
    BFormInput,
    BButton,
    BFormGroup,
  },
  directives: {
    Ripple,
  },
  setup() {
    let chartInstance = null;

    const { skin } = useAppConfig();
    const isDark = computed(() => skin.value === "dark");

    let datasetsMap = {};
    let labels = [];

    const fetchData = async () => {
      let products = await axios.get("/v1/count_product/history");

      products.data.forEach((data) => {
        labels.push(Object.keys(data)[0]);

        Object.keys(data[Object.keys(data)[0]]).forEach((data1) => {
          if (!datasetsMap[data1]) {
            datasetsMap[data1] = {
              label: data1,
              backgroundColor: dynamicColors(),
              borderColor: dynamicColors(),
              data: [],
              tension: 0.1,
              fill: false,
            };
          }
          datasetsMap[data1].data.push(data[Object.keys(data)[0]][data1]);
        });
      });
    };

    const dynamicColors = function () {
      let r = Math.floor(Math.random() * 255);
      let g = Math.floor(Math.random() * 255);
      let b = Math.floor(Math.random() * 255);
      return `rgb(${r},${g},${b})`;
    };

    setInterval(fetchData, 5000);

    const createChart = async () => {
      await nextTick();

      const ctx = document.getElementById("chart-history");

      chartInstance = new Chart(ctx, {
        type: "line",
        data: {
          labels: labels,
          datasets: Object.values(datasetsMap),
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              ticks: {
                color: isDark.value ? "#fff" : "#000",
              },
            },
            y: {
              ticks: {
                stepSize: 1,
                color: isDark.value ? "#fff" : "#000",
              },
            },
          },
          plugins: {
            legend: {
              position: "top",
              labels: {
                font: {
                  size: 12,
                  weight: 500,
                },
                color: isDark.value ? "#fff" : "#000",
              },
            },
          },
        },
      });
    };

    const destroyChart = () => {
      if (chartInstance) {
        chartInstance.destroy();
        chartInstance = null;
      }
    };

    watch(isDark, () => {
      destroyChart();
      createChart();
    });

    nextTick(async () => {
      await fetchData();
      createChart();
    });

    onBeforeUnmount(() => {
      destroyChart();
    });

    return {};
  },
};
</script>

<style lang="scss" scoped>
.product-count-chart-history-slot {
  width: 100%;
  height: 100%;
}

.frame {
  width: 100% !important;
  height: 100% !important;
  border: none;
  overflow: hidden;
}
</style>
